import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { formatPhoneNumber } from '../utils/paymentLinks.utils';

interface SendForm {
  type: string;
  value: string;
}

interface SendLinkDialogProps {
  open: boolean;
  sendForm: SendForm;
  setSendForm: React.Dispatch<React.SetStateAction<SendForm>>;
  sending: boolean;
  onClose: () => void;
  onSend: () => void;
}

export const SendLinkDialog = ({
  open,
  sendForm,
  setSendForm,
  sending,
  onClose,
  onSend,
}: SendLinkDialogProps) => (
  <Dialog
    open={open}
    onClose={sending ? undefined : onClose}
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle>Enviar link</DialogTitle>
    <DialogContent>
      <Stack spacing={2} mt={1}>
        <Box display="flex" alignItems="center" gap={1} color="text.secondary">
          <InfoOutlinedIcon fontSize="small" />
          <Typography variant="caption">
            O link de pagamento será enviado pelo canal escolhido.
          </Typography>
        </Box>
        <FormControl size="small" fullWidth disabled={sending}>
          <InputLabel>Canal</InputLabel>
          <Select
            label="Canal"
            value={sendForm.type}
            onChange={(event) =>
              setSendForm((state) => ({ ...state, type: event.target.value }))
            }
          >
            <MenuItem value="Whatsapp">WhatsApp</MenuItem>
            <MenuItem value="Email">E-mail</MenuItem>
          </Select>
        </FormControl>
        <TextField
          disabled={sending}
          label="Destino"
          size="small"
          placeholder={
            sendForm.type === 'Email'
              ? 'cliente@email.com'
              : 'DDD + número (ex.: 11999998888)'
          }
          value={sendForm.value}
          inputProps={{ maxLength: 180 }}
          onChange={(event) =>
            setSendForm((state) => ({
              ...state,
              value:
                state.type === 'Whatsapp'
                  ? formatPhoneNumber(event.target.value)
                  : event.target.value,
            }))
          }
          fullWidth
        />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={sending}>
        Cancelar
      </Button>
      <LoadingButton
        loading={sending}
        variant="contained"
        startIcon={<SendIcon />}
        onClick={onSend}
      >
        Enviar
      </LoadingButton>
    </DialogActions>
  </Dialog>
);

export default SendLinkDialog;
